import styled from 'styled-components';
var ItemDetailsHeader = styled.div.withConfig({
  displayName: "ItemDetailsHeader",
  componentId: "sc-146s9fo-0"
})([""]);
export default ItemDetailsHeader;